import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.FRONTEND_SENTRY_DSN,
  tracesSampleRate: 0,
  sendDefaultPii: true
});
